var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/users/resetPwd"}},[_c('van-cell',{attrs:{"title":"修改密码","is-link":"","url":""}})],1),_vm._v(" "),_c('Floating',{attrs:{"toUrl":"/users/index"}}),_vm._v(" "),_c('wxNoShare')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254794c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/security.vue
// module id = null
// module chunks = 